import React from 'react'
import AuditFormPrivewUi from './AuditFormPrivewUi'

function AuditFormPrivew({values}) {
  return (
    <AuditFormPrivewUi values={values}/>
  )
}

export default AuditFormPrivew